import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AssigneeItem} from "../../../../util/task-record-utils";
import {CustomerRecord, CustomerRecordService} from "../../../../lib/customer/customer-record.service";
import {Set} from "immutable";
import {StringKey} from "../../../../app.string-keys";
import {ToasterService} from "../../../../fork/angular2-toaster/src/toaster.service";
import {MultiselectOptionItem, UiConstants} from "../../../../util/core-utils";
import {TranslateService} from "@ngx-translate/core";
import {UserMultiselectProvider} from "../../../../lib/user/user-multiselect.provider";
import {UserGroupMultiselectProvider} from "../../../../lib/user-group/user-group-multiselect.provider";
import {Angular2Multiselects} from "../../../../util/multiselect";

@Component({
  selector: 'app-customer-record-owner-modify-dialog',
  templateUrl: './customer-record-owner-modify-dialog.component.html',
  styleUrls: ['./customer-record-owner-modify-dialog.component.scss']
})
export class CustomerRecordOwnerModifyDialogComponent implements OnInit {

  ownerChangeModel: OwnerChangeModel = new OwnerChangeModel();
  users: MultiselectOptionItem<number>[];
  userGroups: MultiselectOptionItem<number>[];

  remoteSearchDropdownSettings: Angular2Multiselects.Settings = Angular2Multiselects.REMOTE_MULTI_SELECT;

  constructor(
    private customerRecordService: CustomerRecordService,
    private toasterService: ToasterService,
    private translateService: TranslateService,
    private userMultiselectProvider: UserMultiselectProvider,
    private userGroupMultiselectProvider: UserGroupMultiselectProvider,
    public dialogRef: MatDialogRef<CustomerRecordOwnerModifyDialogComponent, CustomerRecordOwnerModifyDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: CustomerRecordOwnerModifyDialogData) {
    this.ownerChangeModel = new OwnerChangeModel();
    this.ownerChangeModel.changeUsers = data.allowUserChange;
    this.ownerChangeModel.changeUserGroups = data.allowUserGroupChange;
    this.ownerChangeModel.customerRecordIds = data.customerRecordIds;
  }

  ngOnInit(): void {
  }

  public static openDialog(
    dialog: MatDialog,
    data: CustomerRecordOwnerModifyDialogData,
    resultCallback: (result?: CustomerRecordOwnerModifyDialogResult) => void) {
    const dialogRef = dialog.open(CustomerRecordOwnerModifyDialogComponent, {
      closeOnNavigation: true,
      data: data,
      width: '60%',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe((result: CustomerRecordOwnerModifyDialogResult) => {
      resultCallback(result);
    });
  }

  loadOwnerUsersForChange(q?: string) {
    this.userMultiselectProvider.loadActive(q).subscribe((result) => {
      this.users = result;
    });
  }

  loadOwnerUserGroupsForChange(q?: string) {
    this.userGroupMultiselectProvider.loadActive(q).subscribe(result => {
      this.userGroups = result;
    })
  }

  changeOwners() {
    this.customerRecordService.changeOwners({
      customerRecordIds: Set.of(...this.ownerChangeModel.customerRecordIds),
      changeType: this.ownerChangeModel.changeType,
      ownerUserIds: this.ownerChangeModel.changeUsers ? Set.of(...this.ownerChangeModel.ownerUsers.map(u => u.id)) : undefined,
      ownerUserGroupIds: this.ownerChangeModel.changeUserGroups ?
        Set.of(...this.ownerChangeModel.ownerUserGroups.map(u => u.id)) : undefined,
    }).subscribe(result => {
      this.toasterService.pop({
        timeout: UiConstants.ToastTimeoutShort,
        type: UiConstants.toastTypeSuccess,
        title: this.translateService.instant(StringKey.CUSTOMER_RECORD_DATA_MODIFY),
        body: this.translateService.instant(StringKey.CUSTOMER_RECORD_DATA_MODIFY_SUCCESS)
      });
    });
    this.closeDialog(true);
  }

  closeDialog(result: boolean) {
    this.dialogRef.close({success: result});
  }
}

export class CustomerRecordOwnerModifyDialogData {
  customerRecordIds: number[];
  allowUserChange: boolean;
  allowUserGroupChange: boolean;
}

export class CustomerRecordOwnerModifyDialogResult {
  success: boolean;
}

class OwnerChangeModel {

  customerRecordIds: number[] = [];

  ownerUsers: AssigneeItem[] = [];

  ownerUserGroups: AssigneeItem[] = [];

  changeUsers: boolean = false;

  changeUserGroups: boolean = false;

  changeType: CustomerRecord.OwnerChangeType = 'ADD';

}
